import React from 'react'
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const VaishaliResidency = () => {
    const carouselVaishaliResidency = {
 items: 1,
        loop: true,
        dots: false,
        margin: 0,
        autoplay: true,
        nav: true,
        navText: ['<i class="ti-angle-left" aria-hidden="true"></i>', '<i class="ti-angle-right" aria-hidden="true"></i>'],
        responsiveClass: true,
        responsive: {
            0: {
                dots: false,
            },
            600: {
                dots: false,
            },
            1000: {
                dots: false,
            }
        }
};
    const carouselSravastiResidencythumb = {
  loop: true,
        margin: 10,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: true,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
};
    return (
        <>
            <header className="headerslider">
               
 <OwlCarousel className="owl-theme first-carousel" {...carouselVaishaliResidency}>
     <div className='item'>
                    <img src='img/slider/Vaishali-slider-1.jpg' loading="lazy" alt="hotel" class="img-fluid" />
                </div>
                 <div className='item'>
                    <img src='img/slider/Vaishali-slider-2.jpg' loading="lazy" alt="hotel" class="img-fluid" />
                </div>
                 <div className='item'>
                    <img src='img/slider/Vaishali-slider-3.jpg' loading="lazy" alt="hotel" class="img-fluid" />
                </div>
                 <div className='item'>
                    <img src='img/slider/Vaishali-slider-4.jpg' loading="lazy" alt="hotel" class="img-fluid" />
                </div>
                 <div className='item'>
                    <img src='img/slider/Vaishali-slider-5.jpg' loading="lazy" alt="hotel" class="img-fluid" />
                </div>
                   
                   </OwlCarousel>
      
                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll" aria-label="Scroll to section"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </header>

            <section className="room-details1 section-padding" data-scroll-index="1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-title">The Vaishali Residency</div>
                        </div>
                        <div className="col-md-8">
                           <p>Nestled in the ancient city of Vaishali, Bihar. Our hotel features 79 comfortable rooms, 
                            offering a serene retreat for travelers exploring the region's rich Buddhist heritage.</p>

                           <p>Vaishali, a sacred site in Buddhism, was where Lord Buddha preached his last sermon and announced
                             his Mahaparinirvana. 
                            The city is home to the iconic Ashokan Pillar and other ancient ruins, holding significant 
                            historical and spiritual importance.  According to Jain scriptures, Vaishali was an important
                             center for Jainism, and Lord Mahavira, the 24th Jain Tirthankara, spent time here during his
                              lifetime. The city is believed to be associated with several events and teachings of Lord Mahavira, 
                              making it a revered site for Jains.</p>

                           <p>At Vaishali Residency, we blend modern comforts with a deep connection to the region's 
                            cultural legacy. The hotel is located a walking distance to vishwa shanti stupa. All the rooms have vault facility and parking
                             facility available to suit group accommodations as well. 
                            The Hotel is Recognized by Department of Tourism, Government of Bihar and We
                             are also Members of FHRAI and HRAEI.</p>
                           <p></p>
                            <div className="row">
                                <div className="col-md-6">
                                    <h6>Check-in</h6>
                                    <ul className="list-unstyled page-list mb-30">
                                        <li>
                                            <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                            <div className="page-list-text">
                                                <p>Check-in - 2 PM</p>
                                            </div>
                                        </li>
                                       
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <h6>Check-out</h6>
                                    <ul className="list-unstyled page-list mb-30">
                                        <li>
                                            <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                            <div className="page-list-text">
                                                <p>Check-out - 12 Noon</p>
                                            </div>
                                        </li>
                                      
                                    </ul>
                                </div>
                               <div className="col-md-12 content">
                                <div className="cont">
                                    <h3>Address</h3>
                                    <p> Stupa Road, Dist. - Vaishali - 844128, Bihar (India)<br />
                                        <strong>Mob. No. :</strong> <a href='tel:+91 92893 00356'> +91 92893 00356</a>		<br />
                                        <strong>Tel No. :</strong> -<a href='tel:+91 6112 - 255404'> +91 6112 - 255404, 255405</a><br />
                                        <strong>Email :</strong>-<a href='mailto:thevaishaliresidency@gmail.com'> thevaishaliresidency@gmail.com,</a> <br />
                                        </p>
                                </div>
                            </div>

                            </div>
                        </div>
                        <div className="col-md-3 offset-md-1">
                            <h6>Facilities of The Vaishali Residency</h6>
                            <p>The Vaishali Residency provides deluxe air-condition rooms include
                                the following facilities</p>
                            <ul className="mb-30">
                                <li>Multi Cuisine Food</li>
                                <li>24 Hour Hot & Cold Shower</li>
                                <li>Multi-lingual satellite T.V.</li>
                                <li>24 Hour Uninterrupted Power Supply</li>
                                <li>Free High Speed Wi-Fi connectivity</li>
                                <li>Hair Dryer</li>
                                <li>Laundry Services</li>
                                <li>Shopping Arcade</li>
                                <li>Tea / Coffee maker</li>
                                <li>Doctor on call</li>
                                <li>Room service</li>

                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="rooms5 section-padding bg-white" data-scroll-index="1">
                <div className="container">
                    <div className="section-title">Room Type</div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/v-room-1.jpg" loading="lazy" alt="hotel" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Deluxe Single Room</Link></h3>
                                    <div className="row room-facilities mb-15">
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i className="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                       <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-bed"></i> Single Bed</li>
                                                <li><i className="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                   </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/v-room-2.jpg" loading="lazy" alt="hotel" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Deluxe Twin/Double Room</Link></h3>
                                   <div className="row room-facilities mb-15">
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i className="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-bed"></i> Twin Bed</li>
                                                <li><i className="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                   </div>
                            </div>
                        </div>
                        
                       
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-1.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-1.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-5.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-5.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-6.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-6.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-7.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-7.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-8.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-8.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-9.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-9.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-10.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-10.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                         <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-18.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-18.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-11.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-11.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-12.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-12.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-13.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-13.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-14.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-14.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-15.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-15.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-16.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-16.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/vaishali-17.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/vaishali-17.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                      
                       
                    </div>
                </div>
            </section>
             <section className="section-padding">
                            <div className="container">
                                 <div className="section-title">Places of Attraction</div>
                                 <OwlCarousel className="owl-theme first-carousel" {...carouselSravastiResidencythumb}>
                                <div className="item thumb">
                                    <img src='img/slider/Buddha.jpg' alt='' />
                                    <p>Buddha relic museum</p>
                                </div>
                                
                               <div className="item thumb">
                                    <img src='img/slider/Ashoka.jpg' alt='' />
                                    <p>Ashoka stupa</p>
                                </div>
                                
                                <div className="item thumb">
                                    <img src='img/slider/Vishwa.jpg' alt='' />
                                    <p>Vishwa Shanti Stupa</p>
                                </div>
            
                                <div className="item thumb">
                                    <img src='img/slider/Ashok.jpg' alt='' />
                                    <p>Ashok Pillar</p>
                                </div>
            
                                <div className="item thumb">
                                    <img src='img/slider/Ananda.jpg' alt='' />
                                    <p> Ananda Stupa</p>
                                </div>
            
                                <div className="item thumb">
                                    <img src='img/slider/Lion.jpg' alt='' />
                                    <p>Lion Pillar</p>
                                </div>           
                                <div className="item thumb">
                                    <img src='img/slider/Pushkarni.jpg' alt='' />
                                    <p>Pushkarni Pond</p>
                                </div>           
                                <div className="item thumb">
                                    <img src='img/slider/Darshan.jpg' alt='' />
                                    <p>Buddha Samyak Darshan Park</p>
                                </div>           
                                            
                          </OwlCarousel>
                  
                            </div>
                        </section>

            <section className="bg-white">
                <div className="col-md-12">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3586.2861916337774!2d85.11872291506477!3d25.991440805396508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed383bc96e0f6b%3A0x151fbd6888fb9594!2sThe+Vaishali+Residency+Hotel!5e0!3m2!1sen!2sin!4v1467014886767" width="100%" height="350" frameborder="0" className="mappie" allowfullscreen title="Google Map - The Vaishali Residency"></iframe>

                </div>

            </section>
        </>
    )
};

export default VaishaliResidency;
